import React from 'react';
import { FiBookOpen, FiPlay } from 'react-icons/fi';

const MediaCover = ({ item, compact = false }) => {
  const style = item.thumbnailUrl
    ? { backgroundImage: `linear-gradient(rgba(15, 20, 34, 0.06), rgba(15, 20, 34, 0.38)), url("${item.thumbnailUrl}")` }
    : undefined;

  return (
    <span
      className={`ai-media-cover is-${item.theme || 'violet'}${compact ? ' is-compact' : ''}${item.thumbnailUrl ? ' has-image' : ''}`}
      style={style}
    >
      {!item.thumbnailUrl && (
        <>
          <i className="ai-media-cover__shape is-one" />
          <i className="ai-media-cover__shape is-two" />
          <span className="ai-media-cover__category"><FiBookOpen aria-hidden="true" /> {item.category}</span>
          <strong>{item.tags?.[0] || '교육'}<br />{item.tags?.[1] || '소식'}</strong>
        </>
      )}
      <span className="ai-media-cover__play"><FiPlay aria-hidden="true" /></span>
      {item.duration && <small>{item.duration}</small>}
    </span>
  );
};

export default MediaCover;
